import React, {useState} from "react";

import {buildStyles} from "connectui/component/buildStyles";
import Container from "connectui/component/layout/Container";
import {useTheme} from "connectui/theme/ThemeProvider";
import MessagingSettingsPanel from "./panel/MessagingSettingsPanel";
import ButtonIconText from "connectui/component/input/button/ButtonIconText";
import EmptyButtonBase from "connectui/component/input/button/base/EmptyButtonBase";
import SvgIcon from "connectui/component/display/SvgIcon";
import FlexContainer from "connectui/component/layout/FlexContainer";
import {ReactComponent as BackIcon} from "connectui/icons/back.svg";
import PhoneManagePanel from "./panel/PhoneManagePanel";
import EmailManagePanel from "./panel/EmailManagePanel";
import WhatsAppManagePanel from "./panel/WhatsAppManagePanel";
import WhatsAppManageEmbeddedFlowPanel from "./panel/WhatsAppManageEmbeddedFlowPanel";
import PhoneEditPanel from "./panel/PhoneEditPanel";
import WhatsAppEditPanel from "./panel/WhatsAppEditPanel";

export const messagingSettingsStageEnum = {
  settings: 0,
  phone: 1,
  email: 2,
  whatsApp: 3,
  whatsAppEmbedded: 4,
  phoneEdit: 5,
  whatsAppEdit: 6,
};

const useStyles = (theme) =>
  buildStyles({
    baseContainer: {
      backgroundColor: theme.colors.white,
      width: "100%",
      height: "100%",
      overflowY: "auto",
    },
    contentContainer: {
      width: `100%`,
      height: "100%",
      padding: `0 ${theme.spacing(35)}`,
    },
    headerContainer: {
      background: theme.colors.white,
      position: "sticky",
      top: 0,
      alignSelf: "flex-start",
      padding: `${theme.spacing(3)} 0`,
      width: "100%",
    },
    backButtonContainer: {
      direction: "column",
      alignItems: "center",
      marginTop: theme.spacing(3),
    },
    backIcon: {
      width: "24px",
      height: "24px",
      paddingRight: theme.spacing(1),
      color: theme.colors.textTertiary,
    },
    componentContainer: {
      marginTop: theme.spacing(6),
    },
  });

const BaseMessagingSettingsPanel = () => {
  const {theme} = useTheme();
  const classes = useStyles(theme);

  const [stage, setStage] = useState({
    id: messagingSettingsStageEnum.settings,
    data: {},
    overrideBackToStageId: undefined,
  });

  let stages = [
    {
      id: messagingSettingsStageEnum.settings,
      component: MessagingSettingsPanel,
    },
    {
      id: messagingSettingsStageEnum.phone,
      component: PhoneManagePanel,
      backToStageId: messagingSettingsStageEnum.settings,
    },
    {
      id: messagingSettingsStageEnum.email,
      component: EmailManagePanel,
      backToStageId: messagingSettingsStageEnum.settings,
    },
    {
      id: messagingSettingsStageEnum.whatsApp,
      component: WhatsAppManagePanel,
      backToStageId: messagingSettingsStageEnum.settings,
    },
    {
      id: messagingSettingsStageEnum.whatsAppEmbedded,
      component: WhatsAppManageEmbeddedFlowPanel,
      backToStageId: messagingSettingsStageEnum.whatsApp,
    },
    {
      id: messagingSettingsStageEnum.phoneEdit,
      component: PhoneEditPanel,
      backToStageId: messagingSettingsStageEnum.phone,
    },
    {
      id: messagingSettingsStageEnum.whatsAppEdit,
      component: WhatsAppEditPanel,
      backToStageId: messagingSettingsStageEnum.settings,
    },
  ];

  const currentStage = stages.find((stageItem) => stageItem.id === stage.id);
  let backToStageId = currentStage.backToStageId;
  if (
    stage?.overrideBackToStageId !== undefined &&
    stage?.overrideBackToStageId !== null
  ) {
    backToStageId = stage.overrideBackToStageId;
  }

  return (
    <Container className={classes.baseContainer}>
      <FlexContainer
        className={classes.contentContainer}
        flexDirection={"column"}
      >
        {currentStage?.backToStageId !== undefined && (
          <FlexContainer className={classes.headerContainer}>
            <FlexContainer className={classes.backButtonContainer}>
              <ButtonIconText
                onClick={() => setStage({id: backToStageId, data: {}})}
                typographyVariant="textMD"
                color={"textTertiary"}
                buttonBase={EmptyButtonBase}
                weight="semibold"
                icon={
                  <SvgIcon component={BackIcon} className={classes.backIcon} />
                }
                sx={{padding: 0}}
                label="Back"
              />
            </FlexContainer>
          </FlexContainer>
        )}

        <Container className={classes.componentContainer}>
          {stages.map((stageItem) => {
            if (stageItem.id === stage.id) {
              const Component = stageItem.component;
              return (
                <Component
                  key={stageItem.id}
                  setStage={setStage}
                  data={stage.data}
                />
              );
            }
            return null;
          })}
        </Container>
      </FlexContainer>
    </Container>
  );
};

export default BaseMessagingSettingsPanel;
